import React from 'react';
import {VisualizationSpec} from 'react-vega';
import CustomPanelRenderer from '../Vega3/CustomPanelRenderer';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = {
  type: 'dict' as const,
  objectType: {
    type: 'union' as const,
    members: [null, 'number' as const],
  },
};

type PanelBarChartProps = Panel2.PanelProps<typeof inputType>;

/* eslint-disable no-template-curly-in-string */

const BAR_CHART: VisualizationSpec = {
  $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
  description: 'A simple bar chart',
  data: {
    name: 'wandb',
  },
  title: '${string:title}',
  mark: {
    type: 'bar',
    tooltip: {
      content: 'data',
    },
  },
  encoding: {
    x: {
      field: '${field:value}',
      type: 'quantitative',
      stack: null,
      axis: {
        title: null,
      },
    },
    y: {
      field: '${field:label}',
      type: 'nominal',
      axis: {
        title: null,
      },
    },
    opacity: {
      value: 0.6,
    },
  },
};

const PanelBarChart: React.FC<PanelBarChartProps> = props => {
  const nodeValue = CGReact.useNodeValue(props.input.path);
  if (nodeValue.loading) {
    return <div>-</div>;
  }
  const data = Object.entries(nodeValue.result).map(([key, value]) => ({
    key,
    value,
  }));
  return (
    <CustomPanelRenderer
      spec={BAR_CHART}
      loading={props.loading}
      slow={false}
      data={data}
      userSettings={{
        fieldSettings: {label: 'key', value: 'value'},
        stringSettings: {title: ''},
      }}
    />
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'barchart',
  displayName: 'Bar Chart',
  Component: PanelBarChart,
  inputType,
  canFullscreen: true,
  defaultFixedSize: {
    width: 200,
    height: (9 / 16) * 200,
  },
};
